module.exports = __webpack_public_path__ + "img/ow-square.a58050f.svg";